export const ERRORS = {
	TYPES: {
		SNACKBAR_ERROR: "SNACKBAR_ERROR",
		SNACKBAR_WARNING: "SNACKBAR_WARNING",
		SNACKBAR_INFO: "SNACKBAR_INFO",
		SNACKBAR_SUCCESS: "SNACKBAR_SUCCESS"
	},
	SNACKBAR_ERRORS: {
		INVALID_PHONE_NUMBER: "Error: Phone number should have at least 5 digits.",
		INVALID_EMAIL: "Error: Invalid email address.",
		INVALID_PASSWORD: "Error: Password should have at least 6 characters.",
		INVALID_PASSWORDS: "Error: Passwords do not match.",
		INVALID_NAME: "Error: Name should have at least 2 characters.",
		INVALID_USERNAME: "Error: Username should have at least 3 characters.",
		INVALID_BIRTHDATE: "Error: Birthdate should be in the past.",
		INVALID_ROWS_NUMBER: "Error: No Rows Selected."
	},
	FETCH_ERRORS: {
		IMAGE_URL: "Error fetching image URL:",
		SENSORS_DATA: "Error fetching sensors data.",
		SENSORS: "Error fetching sensors:",
		SNAPSHOT_DOCUMENT: "Error fetching document:",
		CUSTOMER_DOCUMENT: "Error fetching customer document:",
		SITE_DOCUMENT: "Error fetching site document:",
		FLOOR_PLAN_DOCUMENT: "Error fetching floor plan document:"
	},
	UPDATING_ERRORS: {
		PEOPLE_DATA: "Error updating people data:",
		ACTIVE_ANCHOR_DATA: "Error updating active anchor. Please try again later."
	},
	GENERIC_ERRORS: {
		FAILED_API: "Error: Failed. Please try again later.",
		IDENTICAL_FETCH: "Can't re-fetch without changing the parameters."
	},
	SERVER_ERRORS: {
		INTERNAL_SERVER: "Can't make a request for server."
	}
}
